import {
  ADMIN_OTP_VERIFY,
  ADMIN_OTP_VERIFY_SUCCESS,
  ADMIN_OTP_VERIFY_FAILURE,
} from 'store/AdminOtpVerify/AdminOtpVerifyAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const adminOtpVerifyReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADMIN_OTP_VERIFY:
      return { ...state, loading: true };
    case ADMIN_OTP_VERIFY_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case ADMIN_OTP_VERIFY_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default adminOtpVerifyReducer;
